// src/components/probe/ProbeInput.tsx
import React from 'react';

interface ProbeInputProps {
  probeName: string;
  onProbe: (requestId: string) => void;
  isLoading: boolean;
  value: string; // The current request ID to display
  onValueChange: (value: string) => void; // Callback for input changes
  placeholder: string;
}

const ProbeInput: React.FC<ProbeInputProps> = ({ probeName, onProbe, isLoading, value, onValueChange, placeholder }) => {

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim()) {
      onProbe(value.trim());
    }
  };

  return (
    <div className="p-4 border-b border-border-dark">
      {/* <h3 className="text-lg font-semibold mb-3 text-text-light">Probe {probeName}</h3> */}
      <form onSubmit={handleSubmit} className="flex flex-col space-y-3">
        <input type="text" value={value} onChange={(e) => onValueChange(e.target.value)}
          placeholder={placeholder} className="input-field" disabled={isLoading} />
        <button type="submit" className="deriq-action-button" disabled={isLoading}>
          {isLoading ? 'Probing...' : 'Probe'}
        </button>
      </form>
    </div>
  );
};

export default ProbeInput;